import { Typography, Backdrop, CircularProgress  } from '@mui/material';
import { ROText } from './locale';

interface Props {
  text? : string
}

const LoadData = ({text}: Props) => (
  <>
    <Backdrop
      sx={{ color: '#ffffffff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
      onClick={() => {}}
    >
      <div className='absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-lg'>
        <div className='bg-white/70 py-20 rounded-lg text-center w-80'>
          <div className='flex justify-center items-center'>
            <div className='relative inline-flex'>
              <CircularProgress color="warning" size={60} />
            </div>
          </div>
          <div className='block mt-4'>
            <Typography className='color-primary font-semibold font-base animate-pulse'>
              <ROText i18n={text ?? 'loading'} />
              ...
            </Typography>
          </div>
        </div>
      </div>
    </Backdrop>
  </>
);

export default LoadData;
